import Header from './components/template/Header';
import RootLayout from './components/RootLayout';

import {ConfigProvider} from 'antd';
import 'antd/dist/reset.css';

const App = ( {children} ) => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultBorderColor: '#EEE',
            },
          },
        }}
      >
        <Header/>
        <RootLayout/>
      </ConfigProvider>
    </>
  );
}

export default App;
